import React, { useState } from "react";
import "../styles/_formSender.scss";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface Props {}

const FormSender: React.FC<Props> = (props) => {
  const [formData, setFormData] = useState<any>({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  const notifySent = () => {
    toast.success("Your email has been sent successfully", { autoClose: 3000 });
  };
  const notifyError = () => {
    toast.error("Your email was not sent due to an error", { autoClose: 3000 });
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    let error = false;
    if (!formData.name) {
      setNameError(true);
      error = true;
    }
    if (!formData.email) {
      setEmailError(true);
      error = true;
    }
    if (!formData.phone) {
      setPhoneError(true);
      error = true;
    }
    if (!formData.message) {
      setMessageError(true);
      error = true;
    }
    var form_data = new FormData();
    for (var key in formData) {
      form_data.append(key, formData[key]);
    }
    if (!error) {
      try {
        const res = await fetch("https://almare-hotel.com/sendmail.php", {
          method: "POST",
          body: form_data,
        });
        notifySent();
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
      } catch (error) {
        notifyError();
        console.error(error);
      }
    }
   
  };

  return (
    <form onSubmit={handleSubmit}>
      <ToastContainer />
      <div className="form-group">
        <h3>Contact Form</h3>
        <p>For more details and booking, please contact as on:</p>
        <br />
        <input
          type="text"
          name="name"
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder="Name"
          value={formData.name}
          onKeyDown={() => setNameError(false)}
          className="p-2 form-control"
        />
        {nameError && <small className="error-message">Name is required</small>}
        <br />
        <input
          type="email"
          name="email"
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          placeholder="Email"
          value={formData.email}
          onKeyDown={() => setEmailError(false)}
          className="p-2 form-control"
        />
        {emailError && (
          <small className="error-message">Email is required</small>
        )}
        <br />
        <input
          type="text"
          name="phone"
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          placeholder="Phone"
          value={formData.phone}
          onKeyDown={() => setPhoneError(false)}
          className="p-2 form-control"
        />
        {phoneError && (
          <small className="error-message">Phone is required</small>
        )}
        <br />
        <textarea
          name="message"
          onChange={(e) =>
            setFormData({ ...formData, message: e.target.value })
          }
          placeholder="Message"
          value={formData.message}
          onKeyDown={() => setMessageError(false)}
          className="p-2 form-control"
        />
        {messageError && (
          <small className="error-message">Message is required</small>
        )}
        <br />
        <br />
        <button type="submit" className="btn btn-primary w-100">
          Send
        </button>
      </div>
    </form>
  );
};

export default FormSender;
